import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { SlickDirective } from './slick.directive';
export var SlickComponentNgModule = module(baseModuleId + ".slick", [])
    .directive('slick', SlickDirective);
